import {Address} from './address';

export class ManagementContact {
  constructor(public id?: number,
              public name?: string,
              public email?: string,
              public phone?: string,
              public address?: Address) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/management-contact.ts